import convertFirstLetter from '../_internal/_convertFirstLetter';

import toLowerCase from './toLowerCase';

const lowerFirst = convertFirstLetter(toLowerCase);
export default lowerFirst;
